import DocReady from './_doc-ready';

new DocReady(() => {


    /* Reviews stars: Change color with js to overwrite the important */
    const stars = document.querySelectorAll('.stamped-fa.stamped-fa-star');
    if (stars != undefined) {
        stars.forEach(ele => {
            // Now do something
            ele.style.color = "#4178B6";
        });
    }
});



new DocReady(() => {
    var cont = 0;
    const reviewWrap = document.querySelectorAll('.stamped-reviews-widget-wrapper');
    
    if (reviewWrap[0]) {
        //console.log('review');
        var myInt;

        myInt = setInterval(()=>{
            reviewWrap.forEach(widget => {
            reviewsLoaded(widget);
           });
        }, 500);//end setInterval
        

    } else {
        //console.log('no review');
    }
    function reviewsLoaded(widget) {
        //console.log('test ',widget);
        const reviewsloaded = widget.querySelector('.stamped-reviews-title');
        cont++;
        if (cont > 100) { myStopFunction(); console.log('no reviews loaded'); }
        if (reviewsloaded) {
            console.log('Yeah!');
           myStopFunction();
            const ratings = widget.querySelectorAll(".block");
            ratings.forEach(rating => {
                const rDate = rating.querySelector(".stamped-reviews-date");
                const rNewDate = rDate.outerHTML;
                rDate.outerHTML = "";
                const rRating = rating.querySelector(".stamped-reviews-rating").outerHTML;
                const rTitle = rating.querySelector(".stamped-reviews-title").outerHTML;
                const rProductTitle = rating.querySelector(".stamped-reviews-image .stamped-reviews-product-title");
                const rNewProductTitle = rProductTitle.outerHTML;
                rProductTitle.outerHTML = "";
                let rImage = rating.querySelector(".stamped-reviews-image").outerHTML;
                const rMessage = rating.querySelector(".stamped-reviews-message").outerHTML;
                const rReviewsAuthor = rating.querySelector(".stamped-reviews-author").outerHTML;
                const rLocation = rating.querySelector(".stamped-reviews-location").outerHTML;
                rImage = rImage.replace('data-src', 'src');
                const newHTML = rImage + '<div class="r-wrapper">' + rTitle + rNewProductTitle + rMessage + '<div class="r-lastline-wrapper">' + rRating + rReviewsAuthor + rNewDate + '</div></div>';
                rating.querySelector('.stamped-ratings-wrapper').innerHTML = newHTML;

                const arrow = `
                <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
                    <g transform="rotate(-180 19 19)" fill="none" fill-rule="evenodd">
                        <circle fill="#FFF" cx="19" cy="19" r="19"/>
                        <path fill="#2C2A25" fill-rule="nonzero" d="m17 15.802.849-.849 4.093 4.094-4.093 4.093-.849-.848 3.244-3.245z"/>
                    </g>
                </svg>`;

                const buttonLeft = widget.querySelector('#stamped-reviews-widget .stamped-carousel-button-left');
                const buttonRight = widget.querySelector('#stamped-reviews-widget .stamped-carousel-button-right');

                buttonLeft.innerHTML = arrow;
                buttonRight.innerHTML = arrow;
            });
        }
    }

    function myStopFunction() {
        clearInterval(myInt);
    }

});
